import { render, staticRenderFns } from "./NewsHead.vue?vue&type=template&id=e6b03162&scoped=true&"
import script from "./NewsHead.vue?vue&type=script&lang=js&"
export * from "./NewsHead.vue?vue&type=script&lang=js&"
import style0 from "./NewsHead.vue?vue&type=style&index=0&id=e6b03162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b03162",
  null
  
)

export default component.exports